
import { Vue } from "vue-class-component";
import "@/assets/scss/master.scss";

export default class AppView extends Vue {}
